module.exports = __webpack_public_path__ + "img/11.9019d677.png";